import { OrderItemType, PaymentOrderItem } from "modules/api/types/Payment";

const getCouponName = (orderItems: PaymentOrderItem[]): string | undefined =>
  orderItems.find((orderItem) => orderItem.type === OrderItemType.DISCOUNT)
    ?.itemId;

export default getCouponName;
